import { isMongoMediaId } from './placeOrderImageUtils';

/** Map a batch-list media row to the Choose Photos grid shape. */
export const mapDbInteriorToGridImage = (row) => {
  if (!row?._id) return null;

  const id = String(row._id);
  const sourceStagingKey = row.sourceStagingKey || null;
  const croppedStagingKey = row.croppedStagingKey || null;
  const customerUrl = row.url || null;

  return {
    _id: id,
    id,
    url: customerUrl,
    // Crop editor source: the API signs originalUrl from sourceStagingKey (full
    // original). Falling back to url would feed the ~800px crop into recrop.
    originalUrl: row.originalUrl || customerUrl,
    publicId: row.publicId || sourceStagingKey || croppedStagingKey || id,
    stagingKey: sourceStagingKey || row.publicId || null,
    sourceStagingKey,
    croppedStagingKey,
    lineartInputStagingKey: row.lineartInputStagingKey || null,
    ordering: row.ordering ?? 0,
    AIUrl: row.AIUrl || null,
    isGenerating: !!row.isGenerating,
    filename: row.AIinfo?.original_filename || `photo-${id}.jpg`,
    cropData: row.cropData || null,
    cropReview: row.cropReview || null,
    // Drawing state (API drawStatus): "failed" drives the failure screens; drawRetries counts "Try again"s.
    drawStatus: row.drawStatus || null,
    drawRetries: row.drawRetries || 0,
    prepVersion: croppedStagingKey ? 1 : 0,
    isCropped: !!croppedStagingKey,
    cropUploadFailed: false,
  };
};

/** Map a batch-list cover row to the cover grid shape. */
export const mapDbCoverToGridImage = (row) => {
  if (!row?._id) return null;

  const id = String(row._id);
  const sourceStagingKey = row.sourceStagingKey || null;
  const croppedStagingKey = row.croppedStagingKey || null;
  const customerUrl = row.url || null;

  return {
    _id: id,
    id,
    url: customerUrl,
    originalUrl: row.originalUrl || customerUrl,
    publicId: row.publicId || sourceStagingKey || croppedStagingKey || id,
    stagingKey: sourceStagingKey || row.publicId || null,
    sourceStagingKey,
    croppedStagingKey,
    croppedCloudinaryUrl: croppedStagingKey
      ? { url: customerUrl, publicId: croppedStagingKey, stagingKey: croppedStagingKey }
      : null,
    AIUrl: row.AIUrl || null,
    // Kept like the raw rows the "cover done" socket handler stores: step 4 and others find the cover by it.
    isCover: true,
    filename: row.AIinfo?.original_filename || `cover-${id}.jpg`,
    isCropped: !!croppedStagingKey,
    cropData: row.cropData || null,
    cropReview: row.cropReview || null,
    // Drawing state (API drawStatus): "failed" drives the failure screens; drawRetries counts "Try again"s.
    drawStatus: row.drawStatus || null,
    drawRetries: row.drawRetries || 0,
  };
};

/** Resolve Mongo media id from a grid image (id or _id). */
export const resolveGridMediaMongoId = (img) => {
  if (!img) return null;
  if (img._id && isMongoMediaId(String(img._id))) return String(img._id);
  if (img.id && isMongoMediaId(String(img.id))) return String(img.id);
  return null;
};
